"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _themeOptions = require("./theme-options");

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n        &:before {\n          background-color: ", ";\n          content: '';\n        }\n      "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        &:before {\n          background-color: ", ";\n          content: '';\n        }\n      "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        &:before {\n          background-color: ", ";\n          content: '';\n        }\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        &:before {\n          background-color: ", ";\n          content: '';\n        }\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        &:before {\n          background-color: ", ";\n          content: '';\n        }\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        &:before {\n          background-color: ", ";\n          content: '';\n        }\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        &:before {\n          background-color: ", ";\n          content: '';\n        }\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        &:before {\n          background-color: ", ";\n          content: '';\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _default = function _default(theme) {
  switch (theme) {
    case _themeOptions.ThemeVariants.SEASHELL:
      return (0, _uiKit.css)(_templateObject(), _uiKit.Colors.secondaryLight);

    case _themeOptions.ThemeVariants.SEASHELL_ALT:
      return (0, _uiKit.css)(_templateObject2(), _uiKit.Colors.secondaryLight);

    case _themeOptions.ThemeVariants.SEASHELL_CROPPED:
      return (0, _uiKit.css)(_templateObject3(), _uiKit.Colors.secondaryLight);

    case _themeOptions.ThemeVariants.MOCASSIN:
      return (0, _uiKit.css)(_templateObject4(), _uiKit.Colors.secondary);

    case _themeOptions.ThemeVariants.MOCASSIN_ALT:
      return (0, _uiKit.css)(_templateObject5(), _uiKit.Colors.secondary);

    case _themeOptions.ThemeVariants.MOCASSIN_CROPPED:
      return (0, _uiKit.css)(_templateObject6(), _uiKit.Colors.secondary);

    case _themeOptions.ThemeVariants.CLARET:
      return (0, _uiKit.css)(_templateObject7(), _uiKit.Colors.wine);

    case _themeOptions.ThemeVariants.CLARET_ALT:
      return (0, _uiKit.css)(_templateObject8(), _uiKit.Colors.wine);

    case _themeOptions.ThemeVariants.CLARET_CROPPED:
      return (0, _uiKit.css)(_templateObject9(), _uiKit.Colors.wine);

    case _themeOptions.ThemeVariants.BLACK:
      return (0, _uiKit.css)(_templateObject10(), _uiKit.Colors.gray800);

    case _themeOptions.ThemeVariants.BLACK_ALT:
      return (0, _uiKit.css)(_templateObject11(), _uiKit.Colors.gray800);

    case _themeOptions.ThemeVariants.BLACK_CROPPED:
      return (0, _uiKit.css)(_templateObject12(), _uiKit.Colors.gray800);

    case _themeOptions.ThemeVariants.GEM:
      return (0, _uiKit.css)(_templateObject13(), _uiKit.Colors.gem);

    case _themeOptions.ThemeVariants.IMAGE_DARK:
      return (0, _uiKit.css)(_templateObject14(), _uiKit.Colors.transparent);

    case _themeOptions.ThemeVariants.IMAGE_LIGHT:
      return (0, _uiKit.css)(_templateObject15(), _uiKit.Colors.transparent);

    default:
      return (0, _uiKit.css)(_templateObject16(), _uiKit.Colors.white);
  }
};

exports.default = _default;